<style scoped>
.process-list {
  background: #fff !important;
  overflow-y: auto;
}

.process-list .el-tabs,
.search-box {
  margin: 0px 12px;
}

.process-box {
  padding: 0;
}

.flow-dialog {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.flow-dialog .flow-item {
  width: 90%;
  font-weight: bold;
  width: 200px;
  padding: 25px 0;
  text-align: center;
  border: 1px solid rgba(235, 235, 235, 1);
  border-radius: 4px;
  cursor: pointer;
}

.flow-dialog .flow-item:hover {
  color: #fff;
  background: #4fa1a4;
}

.flow-item-active {
  color: #fff;
  background: #4fa1a4;
}

.flow-dialog-title {
  position: relative;
  text-align: left;
  margin-top: 0;
}

.flow-dialog-title .flow-dialog-line {
  position: absolute;
  top: -3px;
  display: inline-block;
  width: 4px;
  height: 24px;
  background: #4fa1a4;
}

.flow-dialog-title .flow-dialog-txt {
  display: inline-block;
  padding-left: 15px;
}

.batch-radio {
  display: flex;
  align-items: center;
  text-align: left;
  margin-bottom: 20px;
}

.batch-radio-title {
  flex-shrink: 0;
  margin-right: 10px;
}
.content-main-box {
  height: calc(100vh - 60px - 35px - 66px - 54px - 80px);
}
</style>
<template>
  <div class="content process-list" v-loading="fullscreenLoading">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部流程" name=""> </el-tab-pane>
      <el-tab-pane label="待处理" name="4"></el-tab-pane>
      <el-tab-pane label="已处理" name="2"></el-tab-pane>
      <el-tab-pane label="我收到的" name="3"></el-tab-pane>
      <el-tab-pane label="我发起的" name="1"></el-tab-pane>
    </el-tabs>
    <div class="search-area process-box">
      <div class="search-box">

        <el-row :gutter="24">
          <el-col :span="6">
            <div class="search-area-div">公司名称</div>
            <el-select v-model="page.tenantGuid" placeholder="请选择" filterable class="ipt-sty" :clearable="true"
              @change="tenantChange">
              <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName"
                :value="item.sendTenantGuid">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">发起人</div>
            <el-select v-model="page.starterGuid" placeholder="请选择" filterable class="ipt-sty" :clearable="true">
              <el-option v-for="item in staffList" :key="item.guid" :label="item.staffName" :value="item.guid">
              </el-option>
            </el-select>
            <!-- <el-input
            v-model="page.staffName"
            :clearable="true"
            class="ipt-sty w70f"
            placeholder="请输入发起人"
          ></el-input> -->
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">审批状态</div>
            <el-select v-model="approveState" @change="selectApprovalState" placeholder="请选择" class="ipt-sty w70f"
              filterable clearable>
              <el-option v-for="item in approvalList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6" class="search-btn-box">
            <el-button size="mini" type="text" @click="showMore = !showMore"
              :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
              {{ showMore? '收起筛选': '更多筛选' }}
            </el-button>
            <el-button size="mini" type="info" @click="getData(true)" v-preventReClick="3000">搜索</el-button>
            <el-button size="mini" type="danger" @click="empty">清空</el-button>
          </el-col>
          <!-- <el-col :span="6" class="mt15">
          <div class="search-area-div">审批时间：</div>
          <el-date-picker
            class="ipt-sty w70f"
            v-model="timeI"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col> -->
        </el-row>
        <el-row :gutter="24" class="mt15" v-show="showMore">
          <el-col :span="6">
            <div class="search-area-div">提交时间</div>
            <el-date-picker class="ipt-sty w70f" v-model="time" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">流程名称</div>
            <el-select v-model="page.flowType" placeholder="请选择" class="ipt-sty w70f" filterable clearable
              @focus="flowTypeChange">
              <el-option v-for="item in flowList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <div class="button-area ">
        <!-- <el-button size="mini" type="info" @click="dialogFlow = true">申请流程</el-button> -->
        <el-button size="mini" type="info" @click="bitchExport" v-loading="fullscreenLoading">批量导出</el-button>
        <!-- <el-button size="mini" type="info" @click="toBatchAudit">批量审核</el-button> -->
      </div>
      <div class="content-main-box"  :style="'height:' + contentMainHeight + 'px;'" style="height:100%">

        <el-table class="mt25" :data="tableData" :height="tableHeight" stripe border v-loading="tableLoading"
          @sort-change="sortChange" @selection-change="handleSelectionChange">
          <!-- <el-table-column
          type="selection"
          width="60"
          header-align="center"
          align="center"
          :selectable="selected"
        ></el-table-column> -->
          <el-table-column label="序号" width="70" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="left" prop="tenantName" label="公司名称" show-overflow-tooltip
            min-width="160"> </el-table-column>
          <el-table-column header-align="center" align="left" prop="flowName" label="流程名称" show-overflow-tooltip
            width="120">
            <template slot-scope="scope">
              {{ scope.row.flowName }}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="left" prop="staffName" label="发起人" show-overflow-tooltip
            width="100"> </el-table-column>
          <el-table-column header-align="center" align="left" prop="organisationName" label="所在部门" show-overflow-tooltip
            min-width="150"> </el-table-column>
          <el-table-column header-align="center" align="left" prop="positionName" label="所在岗位" show-overflow-tooltip
            min-width="150"> </el-table-column>
          <el-table-column header-align="center" align="left" prop="param4" label="负责人" show-overflow-tooltip
            width="100">
            <template slot-scope="scope">
              {{ scope.row.flowType == '00002' ? scope.row.param4 : '-' }}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="left" prop="name" label="审批状态" width="100">
            <template slot-scope="scope">
              <a class="fontC-red" v-if="scope.row.approveState == 'R'">已驳回</a>
              <a class="fontC-4fa1a4" v-if="scope.row.approveState == 'Y'">已通过</a>
              <a v-if="scope.row.approveState == 'N' || scope.row.approveState == 'A'">审批中</a>
              <a class="fontC-bbb" v-if="scope.row.approveState == 'C'">已撤销</a>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="left" prop="date" label="审批时间" width="150" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.approveTime | getTime }}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="left" prop="date" label="提交时间" width="180" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.createTime | getTime }}
            </template>
          </el-table-column>

          <el-table-column header-align="center" label="操作" width="100" fixed="right" align="center">
            <template slot-scope="scope">
              <a class="fontC-409EFF c-pointer" @click="toDetail(scope.row.flowType, scope.row)">详情</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 30, 50]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <el-dialog title="填写通过备注" :visible.sync="dialogVisiblePass" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggestPass"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <el-dialog title="驳回流程" :visible.sync="dialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog title="选择发起流程" :visible.sync="dialogFlow" width="900px" top="15%">
      <p class="flow-dialog-title">
        <span class="flow-dialog-line"></span> <span class="flow-dialog-txt">线上会议</span>
      </p>
      <div class="flow-dialog">
        <div :class="flowSelectType == 1 ? 'flow-item flow-item-active' : 'flow-item'" @click="flowSelect(1)">
          会议任务申请
        </div>
        <div :class="flowSelectType == 2 ? 'flow-item flow-item-active' : 'flow-item'" @click="flowSelect(2)">
          线上会议执行2
        </div>
        <div :class="flowSelectType == 3 ? 'flow-item flow-item-active' : 'flow-item'" @click="flowSelect(3)">
          会议任务总结
        </div>
        <div :class="flowSelectType == 4 ? 'flow-item flow-item-active' : 'flow-item'" @click="flowSelect(4)">
          学术活动
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain size="mini" @click="dialogFlow = false">取消</el-button>
        <el-button size="mini" type="info" @click="submitFlow()">确定</el-button>
      </span>
    </el-dialog> -->
    <el-dialog title="批量审核" :visible.sync="dialogBatch" width="400px" top="15%" :close-on-click-modal="false">
      <div class="batch-radio">
        <div class="batch-radio-title">审核类型：</div>
        <el-radio v-model="batchRadio" label="Y">通过</el-radio>
        <el-radio v-model="batchRadio" label="N">驳回</el-radio>
      </div>
      <el-input type="textarea" :rows="5" placeholder="请填写审核原因" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toSubmitAudit()" :loading="btnLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 300,
      activeName: '',
      value: '',
      value1: '',
      value2: '',
      time: [],
      timeI: [],
      approvalList: [
        { label: '全部', value: '' },
        { label: '审批中', value: 'W' },
        { label: '已通过', value: 'Y' },
        { label: '已驳回', value: 'R' },
        { label: '已撤销', value: 'C' },
      ],
      approveState: '',
      flowList: [],
      tableData: [],
      page: {
        pageIndex: 1,
        tenantGuid: '',
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        staffGuid: '',
        listType: 0,
        flowType: '',
        approveState: '',
        approveState1: '',
        staffName: '',
        tenantName: '',
        startTime: '',
        endTime: '',
        flowTypeList: ['00006', '00007', '00008'],
        startApproveTime: null,
        endApproveTime: null,
        orderByName: 'create_time', //create_time/approve_time
        orderByType: 'desc', //desc/asc
        starterGuid: '',
        appSideType: 1//1运营端 2药企端 3移动端
      },
      approveSuggest: '',
      approveSuggestPass: '',
      tableLoading: false,
      dialogVisible: false,
      dialogVisiblePass: false,
      rejectGuid: '',
      rejectFlowType: '',
      dialogFlow: false,
      flowSelectType: 0,
      fullscreenLoading: false,
      passGuid: '',
      passFlowType: '',
      currentStaffGuid: '',
      multipleSelection: [],
      dialogBatch: false,
      batchRadio: '',
      btnLoading: false,
      tenantList: [],
      staffList: [],
    };
  },
  watch: {
    showMore(val, oldVal) {
      if(val) {
        this.tableHeight = window.innerHeight - 350;
        return;
      }
      if(!val) {
        this.tableHeight = window.innerHeight - 300;
        return;
      }
    },
  },
  activated() {
    if (sessionStorage.refresh == 1) {
      this.getTenantList(true);
    }
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    if (this.$route.query.approveState) {
      this.time = [];
      this.approveState = this.$route.query.approveState;
      this.page.approveState = this.$route.query.approveState == 'W' ? 'N' : this.$route.query.approveState;
      this.page.approveState1 = this.$route.query.approveState == 'W' ? 'A' : '';
      this.getTenantList();
      // this.getFlowType(true);
    } else {
      this.getTenantList();
      // this.getFlowType();
    }
    this.getToday();
    this.getFormConfig();
  },
  methods: {
    getFormConfig() {
      this.api
        .get(`/${serverConfig.msConfigureService}/function/func/get-by-code?functionCode=WNQYDJD`)
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            if (data && data.fieldList) {
              data.fieldList.filter(i => {
                return (i.appSideType == '0' || i.appSideType == '1') && i.showPosition.indexOf('1') > -1;
              })
              localStorage.setItem('WNQYDJD_CONFIG', JSON.stringify(data))
            }
            if (!resp.data.data) {
              localStorage.removeItem('WNQYDJD_CONFIG')
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //获取公司列表
    getTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
          // self.page.tenantGuid = self.tenantList[0].sendTenantGuid;
          self.getData(1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    tenantChange(val) {
      if (val) {
        this.getStaffList(val);
        this.getFlowType();
      }
    },
    flowTypeChange() {
      if (!this.page.tenantGuid) {
        this.$message.error('请先选择公司');
      }
    },
    //获取人员列表
    getStaffList(val) {
      let self = this;
      self.api.get(`/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=${val}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.staffList = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    selected(row, index) {
      if (
        row.approveStaffGuid == this.page.staffGuid &&
        row.approveState !== 'Y' &&
        row.approveState !== 'R' &&
        row.approveState !== 'C'
      ) {
        return true;
      } else {
        return false;
      }
    },
    //获取流程类型
    getFlowType() {
      let that = this;
      that.api
        .postJson(
          `/${serverConfig.msConfigureService}/flow/data/get-flow-template-list?tenantGuid=${that.page.tenantGuid}`
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = res.data.data;
            if (data && data.length > 0) {
              let arr = [{ label: '全部', value: "" }];
              let arrNew = [];
              data.forEach((item) => {
                let obj = {
                  value: item.flowType,
                  label: item.flowName,
                };
                //过滤旧流程
                let oldFlowType = ['00001', '00002', '00003', '00004', '00005'];
                let flg = oldFlowType.indexOf(item.flowType);
                if (flg < 0) {
                  arr.push(obj);
                  arrNew.push(item.flowType);
                }
              });
              that.flowList = arr;
              that.page.flowTypeList = arrNew;
            } else {
              that.flowList = [];
              that.page.flowTypeList = [];
            }
          } else {
            that.$message.error(res.data.msg);
          }
        });
    },
    //排序-时间
    sortChange(column) {
      this.page.orderByType = column.order == 'ascending' ? 'asc' : 'desc';
      console.log(column);
      if (column.column.label == '审批时间') {
        this.page.orderByName = 'approve_time';
      } else if (column.column.label == '提交时间') {
        this.page.orderByName = 'create_time';
      } else {
        this.page.orderColumn = '';
        this.page.orderByType = '';
      }
      this.getData(); // 查询列表方法
    },
    //批量导出
    bitchExport() {
      let self = this;
      // self.page.flowType = '00006';
      if (self.page.flowType) {
        self.fullscreenLoading = true;
        self.api
          .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/export-flow-report`, self.page)
          .then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.reportJx(
                res.data.data.colNames,
                res.data.data.datas,
                res.data.data.sheetName,
                res.data.data.fileNam,
              );
            } else {
              self.$message.error(res.data.msg);
            }
          });
      } else {
        self.$message.warning('请选择流程名称！');
      }
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    getToday() {
      let date = new Date(),
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      var time1 = year + '-' + month + '-' + '01';
      var time2 = year + '-' + month + '-' + day;
      this.time = [time1, time2];
      this.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if (self.time && self.time.length) {
        self.page.startTime = self.time[0] + ' ' + '00:00:00';
        self.page.endTime = self.time[1] + ' ' + '23:59:59';
      } else {
        self.page.startTime = null;
        self.page.endTime = null;
      }
      if (self.timeI && self.timeI.length > 0) {
        self.page.startApproveTime = self.timeI[0] + ' ' + '00:00:00';
        self.page.endApproveTime = self.timeI[1] + ' ' + '23:59:59';
      }
      if (self.page.listType == 4 || self.page.listType == 3) {
        self.page.staffGuid = self.currentStaffGuid;
      } else {
        self.page.staffGuid = '';
      }
      self.tableLoading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-flow-list`, self.page)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableLoading = false;
            self.tableData = res.data.data.records || [];
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    empty() {
      let self = this;
      self.time = [];
      self.timeI = [];
      self.approveState = '';
      if (self.page.listType == 4) {
        self.page = {
          pageIndex: 1,
          tenantGuid: '',
          pageSize: 10,
          totalPage: 0,
          totalRows: 0,
          staffGuid: self.page.staffGuid,
          listType: self.page.listType,
          flowType: '',
          approveState: 'N',
          approveState1: 'A',
          staffName: '',
          tenantName: '',
          flowTypeList: self.page.flowTypeList,
          startApproveTime: null,
          endApproveTime: null,
          orderByName: self.page.orderByName, //create_time/approve_time
          orderByType: self.page.orderByType, //desc/asc
          starterGuid: '',
          appSideType: 1//1运营端 2药企端 3移动端
        };
      } else {
        self.page = {
          pageIndex: 1,
          tenantGuid: '',
          pageSize: 10,
          totalPage: 0,
          totalRows: 0,
          staffGuid: '',
          listType: self.page.listType,
          flowType: '',
          approveState: '',
          approveState1: '',
          staffName: '',
          tenantName: '',
          flowTypeList: self.page.flowTypeList,
          startApproveTime: null,
          endApproveTime: null,
          orderByName: self.page.orderByName, //create_time/approve_time
          orderByType: self.page.orderByType, //desc/asc
          starterGuid: '',
          appSideType: 1//1运营端 2药企端 3移动端
        };
      }
      self.staffList = [];
      self.getData();
    },
    //选择流程
    flowSelect(type) {
      this.flowSelectType = type;
    },
    submitFlow() {
      this.dialogFlow = false;
      if (this.flowSelectType == 1) {
        this.$router.push('/costApprove?productGuid=' + this.$route.query.productGuid);
      } else if (this.flowSelectType == 2) {
        this.$router.push('/onlineApprove?productGuid=' + this.$route.query.productGuid);
      } else if (this.flowSelectType == 3) {
        this.$router.push('/reimbursementApprove?productGuid=' + this.$route.query.productGuid);
      } else if (this.flowSelectType == 4) {
        this.$router.push('/academicApprove?productGuid=' + this.$route.query.productGuid);
      }
    },
    selectApprovalState(value) {
      if (value == 'W') {
        this.page.approveState = 'N';
        this.page.approveState1 = 'A';
      } else {
        this.page.approveState = value;
        this.page.approveState1 = '';
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      let self = this;
      self.page.listType = Number(tab.name);
      if (tab.name == 4 || self.approveState == 'W') {
        self.page.approveState = 'N';
        self.page.approveState1 = 'A';
      } else {
        self.page.approveState = self.approveState;
        self.page.approveState1 = '';
      }
      this.getData();
    },

    toDetail(flowType, row) {
      let self = this;
      sessionStorage.clear();
      let query = {
        guid: row.guid,
        bizGuid: row.bizGuid,
        approveStaffGuid: row.approveStaffGuid,
        organisationName: row.organisationName,
        camundaInstanceId: row.camundaInstanceId,
        camundaDeploymentId: row.camundaDeploymentId,
        objectGuid: row.objectGuid,
        tenantGuid: row.tenantGuid,
        submitStaffGuid: row.staffGuid,
        submitStaffName: row.staffName,
        productGuid:this.$route.query.productGuid
      };
      if (flowType == '00006') {
        this.$router.push({
          path: '/pharmacyPageDetail-06',
          query: query,
        });
      } else if (flowType == '00007') {
        this.$router.push({
          path: '/pharmacyPageEditDetail-07',
          query: query,
        });
      } else if (flowType == '00008') {
        this.$router.push({
          path: '/pharmacyLevelDetail-08',
          query: query,
        });
      }
    },
    //重新提交
    reSubmit(flowType, guid, bizGuid) {
      let query = {
        bizGuid: bizGuid,
        guid: guid,
      };
      if (flowType == '00001') {
        this.$router.push({
          path: '/costApprove',
          query: query,
        });
      } else if (flowType == '00003') {
        this.$router.push({
          path: '/reimbursementApprove',
          query: query,
        });
      }
    },
    //多选
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach((item) => {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>